export enum OverridePages {
  PLACE_ORDER = 'PLACE_ORDER',
}

export interface ICustomOverridePage {
  id: number;
  name: string;
  url: string;
  overridePage: OverridePages;
}
